import React from "react";
import { formatRelative } from "date-fns";
import { es } from "date-fns/locale";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import AssignmentIcon from "@material-ui/icons/Assignment";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import ContentCardDetails from "./cards/ContentCardDetails";
import ContentCardFiles from "./cards/ContentCardFiles";

const TicketDetails = ({ ticket, mobile, onSelectCard, onClickFile }) => {
  const handleSelectCard = option => {
    switch (option) {
      case "details":
        onSelectCard(<ContentCardDetails />);
        break;
      default:
        onSelectCard(null);
        break;
    }
  };

  return mobile ? (
    <List>
      <ListItem button onClick={() => handleSelectCard("details")}>
        <ListItemIcon>
          <AssignmentIcon />
        </ListItemIcon>
        <ListItemText
          primary={ticket.title}
          secondary={
            <>
              {formatRelative(new Date(ticket.fecha_creacion_ticket), Date.now(), {
                locale: es
              })}
              <br />
              {ticket.alias_cuenta}
            </>
          }
          secondaryTypographyProps={{ variant: "caption" }}
        />
      </ListItem>

      <Divider />

      <ListItem button onClick={() => handleSelectCard("files")}>
        <ListItemIcon>
          <AttachFileIcon />
        </ListItemIcon>
        <ListItemText primary={`${ticket.archivos.length} archivos adjuntos`} />
      </ListItem>
    </List>
  ) : (
    <>
      <ContentCardDetails
        mobile={mobile}
        ejecutivo={ticket.usuario}
        fecha={ticket.body_ticket.fecha}
        cuenta={ticket.alias_cuenta}
      />
      <ContentCardFiles mobile={mobile} archivos={ticket.archivos} onClick={onClickFile} />
    </>
  );
};

export default TicketDetails;
